"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExport(object) {
    return checkExport(object).fulfilled;
}
exports.isExport = isExport;
function checkExport(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasNumber("requestTime").integer(), __1.hasString("userId"), __1.hasChoice("resourceType", ["project", "times"]), __1.hasString("resourceId"), __1.hasString("format"), __1.hasMap("filter", __1.isAny()), __1.hasChoice("state", ["requested", "in-progress", "failed", "errored", "complete"]), __1.hasString("location").optional()).withOptions(options).explain();
}
exports.checkExport = checkExport;
//# sourceMappingURL=Export.js.map